export enum IndigenousStatusEnum {
    AboriginalButNotTorresStraitIslanderOrigin = '1',
    TorresStraitIslanderButNotAboriginalOrigin = '2',
    BothAboriginalAndTorresStraitIslanderOrigin = '3',
    NeitherAboriginalNorTorresStraitIslanderOrigin = '4',
    NotStatedOrInadequatelyDescribed = '9'
}